import React from 'react';
import styles from './styles.module.scss';
// import { AdminContext } from '../../../context/AdminContext';
import { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';

const Checkbox = ({
  className = 'nothing',
  checked,
  onChange,
  checkMarkStyle = 'nothing',
  wrapper = 'nothing',
  labelStyle = 'nothing',
  onClick = () => console.log('clicked'),
}) => {
  const { themeColor } = useContext(AdminContext);

  return (
    <div style={{ height: '20px' }} className={wrapper} onClick={onClick}>
      <label className={`${styles.container}  ${className} ${labelStyle}`}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span
          className={`${styles.checkmark}  ${checkMarkStyle} checked`}
        ></span>
      </label>
    </div>
  );
};

export default Checkbox;
